export default "__VITE_ASSET__Bl96RQ5R__"